import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';
import CareersDetailsModel from './careers-details.model.js';
import CareerModel from './career.model.js';

class CareersService {
	fetchCareersDetailsById(lang, id) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/collections/get/Careers?lang=${lang}&filter[_id]=${id}`,
			)
			.then(({ data }) => {
				if (data.entries.length === 0) {
					return Promise.reject();
				}
				return new CareerModel(data.entries[0]);
			})
			.catch(logError);
	}

	getPageData(lang) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/Careers?lang=${lang}`,
			)
			.then(data => data.data)
			.catch(logError);
	}

	getCareers(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/collections/get/Careers?lang=${language}&order=desc`,
			)
			.then(({ data }) => data.entries.map(entry => new CareersDetailsModel(entry)))
			.catch(logError);
	}

	applyCareer(data, file) {
		const formData = new FormData();
		formData.set('form[name]', data.name);
		formData.set('form[email]', data.email);
		formData.set('form[phone]', data.phone);
		formData.set('form[motivation]', data.motivation);
		formData.set('form[nationality]', data.nationality);
		formData.set('form[how]', data.how);
		formData.set('form[other]', data.other);
		formData.set('formfiles[resume]', file);

		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/forms/submit/ApplyCareer?token=${
					process.env.REACT_APP_API_TOKEN
				}`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			)
			.then(res => res)
			.catch(logError);
	}
}
export default new CareersService();
